module.exports = __webpack_public_path__ + "img/lu.4e06269e.svg";